const config = {
  pipedriveUrl: (process.env.PIPEDRIVE_URL ? process.env.PIPEDRIVE_URL : '').trim(),
  backendUrl: (process.env.BACKEND_URL ? process.env.BACKEND_URL : '').trim(),
};

export default config;